
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "./context/AuthContext";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";

import InternLayout from "./pages/InternLayout";
import InternPage from "./pages/InternPage";

import Rapporter from "./pages/rapporter/ReportsPage";
import MessengerPage from "./components/MessagesPage";

// Publika sidor
import DeltagarePage from "./pages/DeltagarePage";
import ArbetsgivarePage from "./pages/ArbetsgivarePage";
import MyndigheterPage from "./pages/MyndigheterPage";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
}

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F8FAFA] text-neutral-600">
        Laddar...
      </div>
    );
  }

  return (
    <>
      <ScrollToTop />

      <Routes>
        {/* Publik startsida */}
        <Route path="/" element={<HomePage />} />

        {/* Publika sidor */}
        <Route path="/deltagare" element={<DeltagarePage />} />
        <Route path="/arbetsgivare" element={<ArbetsgivarePage />} />
        <Route path="/myndigheter" element={<MyndigheterPage />} />

        {/* Login */}
        <Route
          path="/login"
          element={
            user ? <Navigate to="/intern" replace /> : <LoginPage />
          }
        />

        {/* Intern layout */}
        <Route
          path="/intern"
          element={
            user ? <InternLayout /> : <Navigate to="/login" replace />
          }
        >
          {/* Översikt */}
          <Route index element={<InternPage />} />

          {/* Menyalternativ */}
          <Route path="rapporter" element={<Rapporter />} />
          <Route path="forum" element={<MessengerPage />} />

          {/* Kommande sidor */}
          {/* <Route path="dokument" element={<Dokument />} /> */}
          {/* <Route path="aktiviteter" element={<Aktiviteter />} /> */}
          {/* <Route path="installningar" element={<Installningar />} /> */}
        </Route>

        {/* Fallback */}
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />
      </Routes>
    </>
  );
}
